import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { ManageSearch } from "@mui/icons-material";
import { COLORS } from "../utils/colors";

/**
 * Placeholder shown on list pages before the user runs their first search.
 * These pages no longer query on mount so that they open instantly.
 */
const SearchPrompt = ({
  title = "No records loaded yet",
  description = "Key in your search or filter criteria above, then click Search to load the records.",
  hint = "This page does not load automatically, so it opens faster. Clicking Search without any filter loads the default list.",
}) => {
  return (
    <Card sx={{ px: 3, py: 6 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <ManageSearch sx={{ fontSize: 56, color: COLORS.OXYGEN7_PURPLE, mb: 1 }} />
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", maxWidth: 560 }}>
          {description}
        </Typography>
        {hint && (
          <Typography variant="caption" sx={{ color: "text.secondary", mt: 1, maxWidth: 560 }}>
            {hint}
          </Typography>
        )}
      </Box>
    </Card>
  );
};

export default SearchPrompt;
